
<script>import { prism } from "./prism";
import { css } from "emotion";
import { createEventDispatcher } from "svelte";
export let language;
export let defaultCode = "";
export let width = 500;
export let height = 350;
let code = defaultCode;
let formattedCode = "";

$: {
  formattedCode = prism.highlight(code, prism.languages[language], language);
}

const dispatch = createEventDispatcher();

$: {
  dispatch("input", {
    code
  });
}

let displayArea;

const syncScroll = e => {
  displayArea.scrollTop = e.target.scrollTop;
  displayArea.scrollLeft = e.target.scrollLeft;
};

const style = {
  container: css`
            /* Hide scrollbar for Chrome, Safari and Opera */
            pre::-webkit-scrollbar {
                display: none;
            }

            textarea::-webkit-scrollbar {
                display: none;
            }

            /* Hide scrollbar for IE, Edge and Firefox */
            textarea,
            pre {
                -ms-overflow-style: none; /* IE and Edge */
                scrollbar-width: none; /* Firefox */
            }

            padding: 10px 10px 0px 10px;
            background: #1e1e1e;
            ${width === "auto" ? "" : `width: ${width}px;`}
            height: ${height}px;
        `,
  editorWrapper: css`
            position: relative;
            width: 100%;
            height: 100%;
        `,
  displayAreaWrapper: css`
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            padding: 0px;
        `,
  displayStyle: css`
            overflow-x: auto;
            overflow-y: auto;
            width: 100%;
            height: 100%;
            z-index: 1000;
            margin: 0px;
            padding: 0px;
        `,
  editorAreaWrapper: css`
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            z-index: 1001;
        `,
  editorAreaStyle: css`
            background: transparent;
            color: #fff;
            -webkit-text-fill-color: transparent;
            padding: 0;
            margin: 0;
            border: none;
            resize: none;
            outline: 0px none transparent;
            overflow-x: auto;
            overflow-y: auto;
            white-space: nowrap;
            width: 100%;
            height: 100%;
            line-height: 1.5;
            font-size: 13px;
            font-family: Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New",
                monospace;
        `
};</script>


<div class={style.container}>
        <div class={style.editorWrapper}>
            <div class={style.displayAreaWrapper}>
                <pre bind:this={displayArea} class={style.displayStyle}>
                    <code class={`language-${language}`}>
                        {@html formattedCode}
                    </code>
                </pre>
            </div>
            <div class={style.editorAreaWrapper}>
                <textarea on:scroll={syncScroll} spellcheck={false} bind:value={code} class={style.editorAreaStyle} />
            </div>
        </div>
    </div>


<style>

</style>